var map = {
	"./bg-Funded by the EU_NEG.svg": 812,
	"./cs-Funded by the EU_NEG.svg": 813,
	"./da-Funded by the EU_NEG.svg": 814,
	"./de-Funded by the EU_NEG.svg": 815,
	"./el-Funded by the EU_NEG.svg": 816,
	"./en-Funded by the EU_NEG.svg": 468,
	"./es-Funded by the EU_NEG.svg": 817,
	"./et-Funded by the EU_NEG.svg": 818,
	"./fi-Funded by the EU_NEG.svg": 819,
	"./fr-Funded by the EU_NEG.svg": 820,
	"./ga-Funded by the EU_NEG.svg": 821,
	"./hr-Funded by the EU_NEG.svg": 822,
	"./hu-Funded by the EU_NEG.svg": 823,
	"./it-Funded by the EU_NEG.svg": 824,
	"./lt-Funded by the EU_NEG.svg": 825,
	"./lv-Funded by the EU_NEG.svg": 826,
	"./mt-Funded by the EU_NEG.svg": 827,
	"./nl-Funded by the EU_NEG.svg": 828,
	"./pl-Funded by the EU_NEG.svg": 829,
	"./pt-Funded by the EU_NEG.svg": 830,
	"./ro-Funded by the EU_NEG.svg": 831,
	"./sk-Funded by the EU_NEG.svg": 832,
	"./sl-Funded by the EU_NEG.svg": 833,
	"./sv-Funded by the EU_NEG.svg": 834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;